import {Model} from '@vuex-orm/core';
import {ISkill} from '@/interfaces/planner/purpose/ISkill';

// @ts-ignore
export default class Skill extends Model implements ISkill {
    public static entity = 'master_skills';

    public static fields() {
        return {
            id: this.number(0),
            text: this.string(''),
            codigo: this.string(''),
            disabled: this.boolean(false),
            created_at: this.string(new Date().toISOString().substr(0, 10)),
            update_at: this.string(new Date().toISOString().substr(0, 10)),
        };
    }
}
